import React, { useEffect, useMemo, useState } from "react";
import DataTable, { TableColumn } from "react-data-table-component";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../style/Cancelorder.css";
import { apiAxios } from "../../utils/apiAxios";
// Constants
const API_BASE = process.env.REACT_APP_API_BASE_URL;
interface CancelOrderRow {

  orderId: string
  clinicName: string
  phone: string
  clinicOrderDate: string

  millingHub: string
  millingHubMobileNo: string

  totalAmount: string
  paymentType: string
  status: string

  designerName: string
  designerMobileNo: string

  deliveryPartner: string
  deliveryPartnerMobileNo: string
  deliveryDate: string

  refundAmount: string
  refundDate: string
  refundType: string
  refundReference: string

  cancelledByName: string
  cancelledDate: string

  orderState: string
  cancellationReason : string 
  remark: string
   rejectedReason: string
  rejectedDate: string
   refundId: string
}

const DentistCancelOrder: React.FC = () => {

  const [orders, setOrders] = useState<CancelOrderRow[]>([])
  const [searchText, setSearchText] = useState("")
  const [statusFilter, setStatusFilter] = useState("All")
  const [selectedOrder, setSelectedOrder] = useState<CancelOrderRow | null>(null)
  const [showModal, setShowModal] = useState(false)
  const [loading, setLoading] = useState(true)

  /* ================================
     FETCH DATA FROM API
  ================================= */
  useEffect(() => {

    const fetchCancelledOrders = async () => {

      try {


        const response = await apiAxios.get(`${API_BASE}/Dentist/GetCancelledOrders/${JSON.parse(sessionStorage.getItem("selectedClinic") || "{}").clinicID || null}`);
        const result = await response.data
        console.log("========== CANCELLED ORDERS API RESPONSE ==========");
console.log("Full API Response:", result);
console.log("API Data:", result.dataOne);

        if (result.isSuccess) {
          const mapped: CancelOrderRow[] = result.dataOne.map((item: any) => ({

            orderId: item.orderID,
            clinicName: item.clinicName,
            phone: item.clinicMobileNo,

            clinicOrderDate: formatDate(item.orderCreatedDate),

            millingHub: item.millingHubName ?? "-",
            millingHubMobileNo: item.millingHubMobileNo ?? "-",

            totalAmount: item.amount?.toString() ?? "0",
            paymentType: item.paymentStatus ?? "-",

            status: item.refundStatus ?? "Cancelled",

            designerName: item.designerName ?? "-",
            designerMobileNo: item.designerMobileNo ?? "-",

            deliveryPartner: item.deliveryPartner ?? "-",
            deliveryPartnerMobileNo: item.deliveryPartnerMobileNo ?? "-",

            deliveryDate: formatDate(item.deliveryDate),

            refundAmount: item.refundAmount?.toString() ?? "0",

            refundDate: formatDate(item.refundedOn),

            refundType: item.refundStatus ?? "-",
            refundReference: item.refundReference ?? "-",
            refundId: item.refundId ?? "-",

            cancelledByName: item.cancelledByName ?? "-",

            cancelledDate: formatDate(item.cancelledDate),

            orderState: item.orderState ?? "-",

            cancellationReason: item.cancellationReason ?? "-",
             remark: item.remarks ?? "-",
             rejectedReason: item.rejectedReason ?? "-",
            rejectedDate: formatDate(item.rejectedDate),
           
          }))

          setOrders(mapped)

        }

      } catch (error) {

        console.error("Error fetching cancelled orders:", error)

      } finally {

        setLoading(false)

      }

    }

    fetchCancelledOrders()

  }, [])

  const formatDate = (dateString: string | null) => {
    if (!dateString) return "-";

    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear()).slice(-2);

    return `${day}/${month}/${year}`;
  };

  /* ================================
     SEARCH + FILTER
  ================================= */
  const filteredOrders = useMemo(() => {

    return orders.filter(o => {

      const matchSearch = [
        o.orderId,
        o.clinicName,
        o.phone,
        o.millingHub,
        o.clinicOrderDate,
        o.designerName,
        o.deliveryPartner,
        o.status
      ]
        .filter(Boolean)
        .some(field =>
          field.toString().toLowerCase().includes(searchText.toLowerCase())
        );

      const matchStatus =
        statusFilter === "All" || o.status === statusFilter

      return matchSearch && matchStatus

    })

  }, [orders, searchText, statusFilter])

  /* ================================
     EXPORT CSV
  ================================= */
  const exportCSV = () => {

    const headers = ["OrderID", "Clinic", "Phone", "Date", "Hub", "Amount", "Payment", "Status"]

    const rows = filteredOrders.map(o => [
      o.orderId,
      o.clinicName,
      o.phone,
      o.clinicOrderDate,
      o.millingHub,
      o.totalAmount,
      o.paymentType,
      o.status
    ])

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers, ...rows].map(e => e.join(",")).join("\n")

    const link = document.createElement("a")
    link.href = encodeURI(csvContent)
    link.download = "cancel-orders.csv"
    link.click()

  }

  /* ================================
     STATUS BADGE
  ================================= */
  const getStatusBadge = (status: string) => {

    if (status === "Cancelled")
      return <span className="badge bg-danger">{status}</span>

    if (status === "Refunded")
      return <span className="badge bg-success">{status}</span>

    if (status === "Refund Pending")
      return <span className="badge bg-warning text-dark">{status}</span>

    if (status === "Pending")
      return <span className="badge bg-warning text-dark">{status}</span>

    return <span className="badge bg-secondary">{status}</span>

  }

  /* ================================
     TABLE COLUMNS
  ================================= */
  const columns: TableColumn<CancelOrderRow>[] = [

    { name: "Order ID", selector: row => row.orderId, sortable: true },

    {
      name: "Clinic / Phone No.",
      sortable: true,
      width: "180px",
      cell: (row) => (
        <div>
          <div className="fw-semibold">{row.clinicName}</div>
          <div className="text-muted mt-1">{row.phone}</div>
        </div>
      )
    },

    { name: "Order Date", selector: row => row.clinicOrderDate },

    { name: "Milling Hub", selector: row => row.millingHub },

    {
      name: "Amount",
      cell: row => (
        <span className="amount-pill">
          ₹{row.totalAmount}
        </span>
      )
    },

    { name: "Payment", selector: row => row.paymentType },

    {
      name: "Status",
      cell: row => getStatusBadge(row.status),
      width: "150px",
    },

    {
      name: "View",
      cell: row => (
        <button
          className="action-btn edit"
          onClick={() => {

            setSelectedOrder(row)
            setShowModal(true)

          }}
        >
          <i className="bi bi-eye"></i>
        </button>
      ),

    }

  ]

  /* ================================
     DASHBOARD COUNTS
  ================================= */
  const totalOrders = orders.length
  
  // const cancelled = orders.filter(o => o.status === "Cancelled" || o.status === "Rejected").length
  const refunded = orders.filter(o => o.status?.toUpperCase() === "PROCESSED").length;
  const pending = orders.filter(o => o.status?.toUpperCase() === "INITIATED").length;

  return (

    <div className="container-fluid mt-4">

      {/* Dashboard Cards */}
      <div className="order-status-bar mb-4">

        <div className="status-col">
          <h3>{totalOrders}</h3>
          <span className="status-badge bgnone">Total Orders</span>
        </div>

        {/* <div className="status-col">
          <h3>{cancelled}</h3>
          <div className="status-badge cancelled">
            <i className="bi bi-dash-circle-fill"></i>
            Cancelled
          </div>
        </div> */}
        

        <div className="status-col">
          <h3>{refunded}</h3>
          <div className="badge-box badge-success">
            <i className="bi bi-cash-stack"></i>
            Refunded
          </div>
        </div>

        <div className="status-col">
          <h3>{pending}</h3>
          <div className="status-badge warning">
            <i className="bi bi-clock-history"></i>
            Refund Pending
          </div>
        </div>

      </div>


      {/* Controls */}

      <div className="row mb-3">
        <div className="col-md-6 col-12 col-lg-3">

          <div className="input-group">
            <input
              className="form-control cancel-order-searchbtn"
              placeholder="Search order..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
            <button className="btn btn-primary" type="button">
              <i className="bi bi-search"></i>
            </button>
          </div>
        </div>
        <div className="col-md-6 col-12 col-lg-9 ">
          <div className="d-flex gap-2 justify-content-center justify-content-lg-end margin-topm10px">


            <select
              className="form-select"
              style={{ width: 180 }}
              onChange={(e) => setStatusFilter(e.target.value)}
            >

              <option>All</option>
              <option>Cancelled</option>
              <option>Refunded</option>
              <option>Refund Pending</option>

            </select>

            {/* <button className="btn btn-success"  onClick={exportCSV}>
  <i className="bi bi-file-earmark-excel-fill me-2"></i>
  Export Excel
</button> */}
          </div>


        </div>

      </div>

      {/* Table */}

      <div className="premium-card p-4">

        <DataTable
          columns={columns}
          data={filteredOrders}
          pagination
          highlightOnHover
          striped
          responsive
          progressPending={loading}
          fixedHeader
          fixedHeaderScrollHeight="500px"
          className="admin-delivery-table"
        />

      </div>

      {/* Modal */}

      {showModal && selectedOrder && (

        <div className="modal fade show d-block modal-bg">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">

              <div className="modal-header premium-modal-header">
                {/* <h5>Order Details</h5> */}
                <h5 className="modal-title"> Order Details: {selectedOrder?.orderId || "--"}</h5>
                <button
                  className="custom-close-btn btn-close "
                  onClick={() => setShowModal(false)}
                >
                  <i className="bi bi-x customcross"></i>
                </button>
              </div>

              <div className="modal-body premium-modal-body">



                {/** new section starts here */}
                <ul className="list-unstyled order-details-list mb-0">

                  {/* <li className="order-item d-flex justify-content-between align-items-center border-bottom py-2">
              <span className="label">Designer</span>
              <span className="value">{selectedOrder.designerName}</span>
            </li> */}

                  {/* <li className="order-item d-flex justify-content-between align-items-center border-bottom py-2">
              <span className="label">Designer Mobile</span>
              <span className="value">{selectedOrder.designerMobileNo}</span>
            </li> */}

                  {/* <li className="order-item d-flex justify-content-between align-items-center border-bottom py-2">
              <span className="label">Milling Hub</span>
              <span className="value">{selectedOrder.millingHub}</span>
            </li> */}

                  {/* <li className="order-item d-flex justify-content-between align-items-center border-bottom py-2">
              <span className="label">Milling Hub Mobile</span>
              <span className="value">{selectedOrder.millingHubMobileNo}</span>
            </li> */}

                  {/* <li className="order-item d-flex justify-content-between align-items-center border-bottom py-2">
              <span className="label">Delivery Partner</span>
              <span className="value">{selectedOrder.deliveryPartner}</span>
            </li> */}
                  {/* <li className="order-item d-flex justify-content-between align-items-center border-bottom py-2">
              <span className="label">Delivery Mobile</span>
              <span className="value">{selectedOrder.deliveryPartnerMobileNo}</span>
            </li> */}
                  {/* <li className="order-item d-flex justify-content-between align-items-center border-bottom py-2">
              <span className="label">Delivery Date</span>
              <span className="value">{selectedOrder.deliveryDate}</span>
            </li> */}

                  <li className="order-item d-flex justify-content-between align-items-center border-bottom py-2">
                    <span className="label">Refund Amount</span>
                    <span className="text-success"> ₹{selectedOrder.refundAmount}</span>
                  </li>
                  <li className="order-item d-flex justify-content-between align-items-center border-bottom py-2">
                    <span className="label">Refund Type</span>
                    <span className="value">{selectedOrder.refundType}</span>
                  </li>
                  <li className="order-item d-flex justify-content-between align-items-center border-bottom py-2">
                    <span className="label">Refund Reference</span>
                    <span className="value">{selectedOrder.refundId}</span>
                  </li>
                  <li className="order-item d-flex justify-content-between align-items-center border-bottom py-2">
                    <span className="label">Refund Date</span>
                    <span className="value">{selectedOrder.refundDate}</span>
                  </li>
                  {/* <li className="order-item d-flex justify-content-between align-items-center border-bottom py-2">
              <span className="label">Cancelled By</span>
              <span className="value">{selectedOrder.cancelledByName}</span>
            </li> */}
                  {/* <li className="order-item d-flex justify-content-between align-items-center border-bottom py-2">
              <span className="label">Cancelled Date</span>
              <span className="value">{selectedOrder.cancelledDate}</span>
            </li> */}
                  <li className="order-item d-flex justify-content-between align-items-center border-bottom py-2">
                    <span className="label">Order State</span>
                    <span className="value">{selectedOrder.orderState}</span>
                  </li>
                 <li className="order-item  py-2">
  <div className="remark-box">
  <h6>Cancellation Details</h6>

  {selectedOrder.cancellationReason && (
    <div className="detail-item">
      <strong>Cancellation Reason:</strong>
      <p>{selectedOrder.cancellationReason}</p>
      <small>{selectedOrder.cancelledDate}</small>
    </div>
  )}

  {selectedOrder.remark &&
    selectedOrder.remark.trim() !== "" &&
    selectedOrder.remark.trim() !== "-" && (
      <div className="detail-item">
        <strong>Remark By Dentist:</strong>
        <p>{selectedOrder.remark}</p>
        <small>{selectedOrder.cancelledDate}</small>
      </div>
    )}

  {selectedOrder.rejectedReason &&
    selectedOrder.rejectedReason.trim() !== "" &&
    selectedOrder.rejectedReason.trim() !== "-" && (
      <div className="detail-item">
        <strong>Rejection Reason By Admin:</strong>
        <p>{selectedOrder.rejectedReason}</p>
        <small>{selectedOrder.rejectedDate}</small>
      </div>
    )}
</div>
</li>




                </ul>
                {/** new section ends here */}

              </div>

            </div>
          </div>
        </div>

      )}

    </div>

  )

}

export default DentistCancelOrder;